import { isExternalUrl } from "../../utils/isExternalUrl";

interface AnchorLinkProps {
  href: string;
  className?: string;
  children: React.ReactNode;
  /** Also renders the external variant unless `forceVariant` says otherwise. */
  download?: boolean;
  /** Forces internal or external colour regardless of `href`. */
  forceVariant?: "internal" | "external";
  nowrap?: boolean;
  target?: "_blank" | "_parent" | "_self" | "_top";
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

function AnchorLink({
  children,
  className,
  download,
  forceVariant,
  href,
  nowrap,
  target = "_blank",
  onClick
}: AnchorLinkProps) {
  const isExternal = forceVariant
    ? forceVariant === "external"
    : download || isExternalUrl(href);

  return (
    <a
      className={className}
      data-variant={isExternal ? "external" : "internal"}
      download={download}
      href={href}
      rel={target === "_blank" ? "noopener noreferrer" : undefined}
      style={nowrap ? { whiteSpace: "nowrap" } : undefined}
      target={target}
      onClick={onClick}
    >
      {children}
    </a>
  );
}

export { AnchorLink };
